import { PropsWithChildren } from "react";
import * as OrgConfig from "src/generated/hooks/org-config/requests";
import { useOrgConfig } from "src/hooks/useOrgConfig";
import { isNullOrUndefined } from "src/services/predicates";
import { DeepReadonly } from "src/types/utils";
import { RemoteDataView } from "../Layout/RemoteDataView";

type Props<T extends OrgConfig.OrgConfig> = PropsWithChildren<{
  configType: OrgConfig.OrgConfigType;
  defaultValue?: DeepReadonly<T>;
  predicate?: (config: DeepReadonly<T> | null) => boolean;
}>;

export function WithConfig<T extends OrgConfig.OrgConfig>({
  children,
  configType,
  defaultValue,
  predicate,
}: Props<T>) {
  const configRD = useOrgConfig<T>(configType, defaultValue);

  return (
    <RemoteDataView remoteData={configRD} error={() => null}>
      {(config) => {
        if (!isNullOrUndefined(predicate)) {
          return predicate(config) ? <>{children}</> : null;
        }

        // AvelaAI and IdentityAI configs expose `enabled`; other configs use `disabled`
        let isEnabled: boolean;
        if (isNullOrUndefined(config)) {
          isEnabled = false;
        } else {
          isEnabled =
            "enabled" in config
              ? config.enabled === true
              : config.disabled !== true;
        }

        return isEnabled ? <>{children}</> : null;
      }}
    </RemoteDataView>
  );
}
